import { IConfig } from "./Render";
export const Rectangle = ({cx, cy, width, height, stroke, stroke_width, fill }:IConfig)=>
{
    return (
       <rect x = {cx} y = {cy} width ={width} height={height} stroke={stroke} strokeWidth={stroke_width} fill={fill} ></rect>
    );
}